import React from 'react';
import { connect } from 'react-redux';

import Lottie from '../Lottie';
import AnimateNumber from '../AnimateNumber';

const Measurement = ({ lottie, point, showUnit, data, className, animate }) => {
  const numberFormatter = Intl.NumberFormat('nl-NL', { maximumFractionDigits: 0 });

  return (
    <div className={className}>
      <Lottie animationName={lottie} />
      {typeof data[point] !== 'undefined' ? (
        <div className="measurement--big" title={`${numberFormatter.format(data[point].value)} ${data[point].unit}`}>
          <AnimateNumber
            toggleBool={animate}
            formattedNumber={numberFormatter.format(data[point].value)}
            endNumber={data[point].value.toFixed()}
          /> {(showUnit && data[point].unit)}
        </div>
      ) : (
        <div className="measurement--big loading" title="Fetching data">-</div>
      )}
    </div>
  );
};

const MeasurementsBlock = ({ className, description, measurements, data, animate }) => {

  description = description
    .replace(/{{today}}/g, new Date().toLocaleDateString('nl-NL', { day: 'numeric', month: 'long', year: 'numeric' }));

  return (
    <div className={className}>
      <div className="o-background--grey paragraph--type--windmill-data__block">
        <p className="measurement--description">{description}</p>
        {measurements.map((value) => {
          return (
            <Measurement
              key={value.point}
              data={data}
              animate={animate}
              {...value}
            />
          );
        })}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {

  return {
    data: state.measurements.getIn(['bazefield', 'measurements']).toJS(),
  };
};

export default connect(mapStateToProps)(MeasurementsBlock);
